(function bsgVariantCompat() {
  // Only run on the main product page, not quick-add panels or collection cards
  var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
  if (!picker) return;

  var colorFieldset = picker.querySelector('fieldset[data-fieldset-index="0"]');
  var formatFieldset = picker.querySelector('fieldset[data-fieldset-index="1"]');
  if (!colorFieldset || !formatFieldset) return;

  // Load the compact variant matrix embedded by Liquid
  var productId = picker.dataset.productId;
  var matrixEl = document.getElementById('bsg-vmatrix-' + productId);
  if (!matrixEl) return;

  var variants;
  try { variants = JSON.parse(matrixEl.textContent); } catch (e) { return; }

  // Build: matrix[color][format] = true if any variant with this combo is available
  var matrix = {};
  variants.forEach(function (v) {
    if (!matrix[v.o1]) matrix[v.o1] = {};
    matrix[v.o1][v.o2] = (matrix[v.o1][v.o2] || false) || v.a;
  });

  function getCheckedColorRadio() {
    return colorFieldset.querySelector('input:checked');
  }

  function getFirstCompatibleColorRadio(fmt) {
    var radios = colorFieldset.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (matrix[radio.value] && matrix[radio.value][fmt]) return radio;
    }
    return null;
  }

  // Use capture phase so our handler runs BEFORE the theme's change handler.
  // This means when variantChanged fires, the colour radio is already corrected
  // and selectedOptionsValues() returns the right pair.
  picker.addEventListener('click', function (e) {
    var label = e.target.closest('.variant-option__button-label');
    if (!label) return;

    var input = label.querySelector('input[type="radio"]');
    if (!input || input.checked) return; // already selected - no change needed

    // Only intercept format (option 2) clicks, not colour clicks
    if (parseInt(input.dataset.fieldsetIndex, 10) !== 1) return;

    var newFormat = input.value;
    var currentColorRadio = getCheckedColorRadio();
    if (!currentColorRadio) return;

    var isCompat = matrix[currentColorRadio.value] && matrix[currentColorRadio.value][newFormat];
    if (isCompat) return; // current colour works with the new format - nothing to do

    // Current colour has no variant for the chosen format.
    // Find the first colour that does and switch to it.
    var firstCompat = getFirstCompatibleColorRadio(newFormat);
    if (!firstCompat) return;

    // Deselect the incompatible colour, select the first compatible one.
    // This happens synchronously in the capture phase, so by the time the
    // theme's variantChanged handler reads selectedOptionsValues(), it sees
    // the corrected (colour, format) pair and fetches the right section.
    currentColorRadio.checked = false;
    firstCompat.checked = true;

    // Update the "selected colour" text shown in the fieldset legend
    var swatchLabel = colorFieldset.querySelector('.variant-option__swatch-value');
    if (swatchLabel) swatchLabel.textContent = firstCompat.value;

  }, true); // true = capture phase

})();

(function bsgInstantVariant() {
  var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
  if (!picker) return;

  var productId = picker.dataset.productId;
  var variantsEl = document.getElementById('bsg-variants-' + productId);
  if (!variantsEl) return;

  var variants;
  try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

  // Preload every unique variant image immediately so the browser has them cached
  var seenFi = {};
  variants.forEach(function (v) {
    if (v.fi && v.src && !seenFi[v.fi]) {
      seenFi[v.fi] = true;
      (new Image()).src = v.src;
    }
  });

  function findVariant(color, format) {
    if (format) {
      var exact = variants.find(function (v) { return v.o1 === color && v.o2 === format; });
      if (exact) return exact;
    }
    return variants.find(function (v) { return v.o1 === color; });
  }

  function swapGalleryImage(variant) {
    if (!variant || !variant.fi) return;
    var mediaId = String(variant.fi);

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // Slides don't carry slide-id; find the one whose child has [data-media-id]
    var slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    var idx = -1;
    slides.forEach(function (slide, i) {
      if (slide.querySelector('[data-media-id="' + mediaId + '"]')) idx = i;
    });
    if (idx < 0) return;

    var slideshow = gallery.querySelector('slideshow-component');
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(idx, undefined, { animate: false });
    }
  }

  // Capture phase: fires before the theme's own change handler
  picker.addEventListener('change', function (e) {
    if (!(e.target instanceof HTMLInputElement)) return;
    var fi = parseInt(e.target.dataset.fieldsetIndex, 10);
    if (fi !== 0) return; // colour fieldset only

    var colorValue = e.target.value;

    // Instant label update
    var label = picker.querySelector('fieldset[data-fieldset-index="0"] .variant-option__swatch-value');
    if (label) label.textContent = ' : ' + colorValue;

    // Instant gallery image
    var fmtInput = picker.querySelector('fieldset[data-fieldset-index="1"] input:checked');
    swapGalleryImage(findVariant(colorValue, fmtInput ? fmtInput.value : null));
  }, true);
})();

(function bsgHoverPrefetch() {
  var pending = {};
  var cache = {};
  var nativeFetch = window.fetch.bind(window);

  // Serve cached variant-section HTML instantly; all other fetches pass through.
  window.fetch = function (url, opts) {
    var key = typeof url === 'string' ? url : String(url);
    if (cache[key]) {
      if (opts && opts.signal && opts.signal.aborted) {
        return Promise.reject(Object.assign(new Error('AbortError'), { name: 'AbortError' }));
      }
      return Promise.resolve(
        new Response(cache[key], { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } })
      );
    }
    return nativeFetch(url, opts);
  };

  function prefetch(url) {
    if (!url || cache[url] || pending[url]) return;
    pending[url] = true;
    nativeFetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) { cache[url] = text; delete pending[url]; })
      .catch(function () { delete pending[url]; });
  }

  function buildUrl(vp, input) {
    var base = (vp.dataset.productUrl || '').split('?')[0];
    var hoveredId = input.dataset.optionValueId;
    if (!base || !hoveredId) return null;

    var hoveredFi = input.dataset.fieldsetIndex;
    var ids = [];
    // Build option_values in DOM fieldset order — must match selectedOptionsValues getter
    Array.from(vp.querySelectorAll('fieldset')).forEach(function (fieldset) {
      if (fieldset.dataset.fieldsetIndex === hoveredFi) {
        ids.push(hoveredId);
      } else {
        var checked = fieldset.querySelector('input:checked');
        if (checked && checked.dataset.optionValueId) ids.push(checked.dataset.optionValueId);
      }
    });
    if (!ids.length) return null;
    return base + '?option_values=' + ids.join(',');
  }

  function setup(vp) {
    vp.querySelectorAll('fieldset input[type="radio"]').forEach(function (input) {
      var label = input.closest('label');
      if (!label) return;
      label.addEventListener('pointerenter', function () {
        prefetch(buildUrl(vp, input));
      }, { passive: true });
    });
  }

  function init() {
    document.querySelectorAll('variant-picker').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
